import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setActiveLanguage,
  getLanguages,
  getActiveLanguage,
} from "react-localize-redux";
import "../../locale";
import "./LanguageSwitcher.css";
import FaAngleDown from "react-icons/lib/fa/angle-down";
import Link from "react-router-dom/es/Link";
import { languageUrls } from "../languageUrls";
import enFlag from "../../assets/images/flags/enFlag.png";

import ruFlag from "../../assets/images/flags/ruFlag.png";
import kaFlag from "../../assets/images/flags/kaFlag.png";

class LanguageSwitcher extends Component {
  handleLanguageChange = () => {
    setTimeout(() => {
      let newSecondParam = "";
      let pathname = window.location.pathname.split("/");
      if (pathname[2]) {
        newSecondParam = languageUrls.filter(
          (item) => item[pathname[1]] === pathname[2]
        )[0];
        console.log(newSecondParam, "newSecondParam");
      }
      pathname[1] = this.props.currentLocale.code;
      if (pathname[1] && pathname[2]) {
        var url = "/" + pathname[1] + "/" + newSecondParam[pathname[1]];
      } else if (pathname[1]) {
        var url = "" + pathname[1];
      }
      if (pathname[3] && pathname[4]) {
        url = url + "/" + pathname[3] + "/" + pathname[4];
      }
      window.history.replaceState(null, "", url);
      // languageUrls.find()
    }, 1);
  };

  render() {
    const { locales, currentLocale, onClick } = this.props;
    return (
      <div>
        <div className="language">
          {" "}
          <p id="currentLang">{currentLocale.name}</p>{" "}
          <img src={currentLocale.flag} /> <FaAngleDown />
        </div>
        <div className="dropdown-content" onClick={this.handleLanguageChange}>
          {locales.map(({ code, name, flag }) => {
            return (
              <a
                onClick={(e) => {
                  onClick(e, code);
                }}
                key={code}
              >
                {" "}
                {name} <img id="flagImage" src={flag} />{" "}
              </a>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ locale }) => ({
  locales: getLanguages(locale),
  currentLocale: getActiveLanguage(locale),
});

const mapDispatchToProps = (dispatch) => ({
  onClick: (e, code) => {
    dispatch(setActiveLanguage(code));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher/LanguageSwitcher.js